import { bl_rvm_cfp_engagement_hdr_RowClass } from '../../../dbschema/bl_rvm_cfp_engagement_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class CfpEngagementHdrContainerModel extends BaseContainerModel {
  bl_rvm_cfp_engagement_hdr: bl_rvm_cfp_engagement_hdr_RowClass = new bl_rvm_cfp_engagement_hdr_RowClass();
}
